<template>
  <div class="container">
    <h4 class="text-center my-4">Список студентов</h4>

    <PrimePreloader v-if="loading"/>

    <div v-else>
      <div class="mt-4">
        <div class="m-3" style="max-width: 100px">
          <select class="form-select" name="" id="" @change="changeCourse($event)">
            <option v-for="(course, course_index) in [1,2,3,4]" :value="course" :key="course_index"
                    :selected="course==course_id">
              {{ course }} курс
            </option>
          </select>
        </div>

        <!-- input ID2 -->
        <input type="hidden" id="alldata">
        <!-- end input ID2 -->

        <!-- Table Start -->
        <DataTable :value="studentsList_form.studentsListInfos"
                   showGridlines stripedRows responsiveLayout="scroll">
          <template #header>
            <div class="p-d-flex p-jc-between p-ai-center">
              <span class="p-input-icon-left">
                        <InputText v-model="name" placeholder="Поиск студента"/>
                        <button @click="getStudentList"><i class="pi pi-search"/></button>
                    </span>
            </div>
          </template>
          <template #empty>
            Студент не найден
          </template>
          <template #loading>
            Идет поиск студентов. Пожалуйста подождите.
          </template>

          <Column field="barcode" header="Баркод">
            <template #body="{data}">
              <router-link :to="'/student/my-profile?student_id=' + data.id" target="_blank"
                           class="text-decoration-none">
                {{ data.barcode }}
              </router-link>

            </template>
          </Column>
          <Column field="last_name" header="ФИО">
            <template #body="{data}">
              <div v-if="data.middle_name == null">
                {{ capitalizeFirstLetter(data.last_name) }} {{ capitalizeFirstLetter(data.first_name) }}
              </div>
              <div v-else>
                {{ capitalizeFirstLetter(data.last_name) }} {{ capitalizeFirstLetter(data.first_name) }}
                {{ capitalizeFirstLetter(data.middle_name) }}
              </div>

            </template>
          </Column>
          <Column field="studentGroups.name" header="Группа" filterField="studentGroups.name">
            <template #body="{data}">
              <div v-if="data.studentGroups == null">
                У студента нет группы
              </div>
              <div v-else>
                {{ data.studentGroups.name }}
              </div>
            </template>
          </Column>
          <Column field="study_course" header="Курс">

            <template #body="{data}">
              {{ data.study_course }}
            </template>

          </Column>
          <Column field="studyLevel.name" header="Уровень обучения">
            <template #body="{data}">
              {{ data.studyLevel.name }}
            </template>
          </Column>
          <Column field="studyLanguage.native_name" header="Язык обучения">

            <template #body="{data}">
              {{ data.studyLanguage.native_name }}
            </template>
          </Column>
          <Column field="paymentType.full_name" header="Источник финансирования"></Column>
          <Column field="education_program_id" header="ОП">
            <template #body="{data}">

              <div v-if="data.educationProgram == null">
                <span class="text-danger">У студента нет ОП</span>
              </div>
              <div v-else>
                {{ data.educationProgram.education_speciality_code }}
                {{ data.educationProgram.education_speciality_name }} -
                {{ data.educationProgram.admission_year }}

              </div>
            </template>

          </Column>
          <Column header="ID2">
            <template #body="{data}">
              <Button label="ID2" @click="openImportFormID2Dialog(data.id)"/>
            </template>


          </Column>

          <Column header="Действия" v-if="!decryptCheckRole('graduateWorkTehSecretary')">

            <template #body="{data}">

              <ul>
                <li class="mb-2">
                  <router-link :to="'/student-transcript?barcode=' + data.barcode" target="_blank"
                               class="text-decoration-none">
                    Транскрипт
                  </router-link>
                </li>
                <li class="mb-2">
                  <router-link :to="'/student-current-attestation?barcode=' + data.barcode" target="_blank"
                               class="text-decoration-none">
                    Атестация
                  </router-link>
                </li>
                <li class="mb-2">
                  <a :href="'https://back.uib.kz/student/transcript/print-transcript?group_id=' + data.study_group_id"
                     target="_blank" class="text-decoration-none">
                    Транскрипт группы
                  </a>
                </li>

              </ul>


            </template>

          </Column>

        </DataTable>
        <Paginator :rows="10"
                   :totalRecords="studentsList_form.pages.totalCount"
                   @page="handlePageChange($event)"></Paginator>
        <!-- Table End -->

        <!-- ImportFromID2 dialog -->
        <Dialog header="Импорт данных из ID2" :visible="displayImportFromID2" :closable="false" :modal="true"
                :style="{width: '100%', maxWidth: '600px'}">
          <div class="my-3">
            <div class="row my-2">
              <div class="col-md-5">Данные студента</div>
              <div class="col-md-7 fw-bold">{{ userNameFront }}</div>
            </div>
            <div class="row my-2">
              <div class="col-md-5">Данные из ID2</div>
              <div class="col-md-7 fw-bold">{{ userNameID2 }}</div>
            </div>
          </div>
          <template #footer>
            <Button label="Закрыть" icon="pi pi-times" @click="closeImportFromID2Dialog" class="p-button-text"/>
            <Button label="Сохранить" icon="pi pi-save"
                    :disabled="disabledSaveImportFromID2"
                    :loading="loadingSaveImportFromID2"
                    @click="saveImportFromID2"
                    autofocus/>
          </template>
        </Dialog>
        <!-- end ImportFromID2 dialog -->

      </div>
    </div>


  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import {toCapitalize} from "@/utils/helpers/string.helpers";
import {convertDateToTimestamp} from "@/utils/helpers/date.helpers";
import {decryptCheckRole} from "@/utils/helpers/decryptedRoles.helpers";

export default {
  name: "Students",
  components: {},
  data() {
    return {
      page: 1,
      course_id: 1,
      name: '',
      studyCourses: [
        '1', '2', '3', '4'
      ],
      studyLevels: ['Бакалавриат', 'Магистратура (1 годичное,профильное)', 'Магистратура (1,5 годичное, профильное)',
        'Магистратура (2 годичное, научно-педагогическое)', 'Докторантура (научно-педагогическое направление)', 'MBA', 'EMBA'],
      studyLanguages: ['русский язык', 'қазақ тілі', 'English'],
      educationPrograms: ['0'],
      loading: true,
      display: false,
      options: [],
      studentGroupsOptions: [],
      groupsDisplay: false,
      courseDisplay: false,
      studyLevelDisplay: false,
      studyLanguageDisplay: false,
      barcodeDisplay: false,
      addStudentPreviousEducationDocumentDisplay: false,
      infoStudentPreviousEducationDocumentDisplay: false,
      infoStudentId: null,
      formStudentData: {},
      formAdditionalData: {},
      displayImportFromID2: false,
      disabledSaveImportFromID2: false,
      loadingSaveImportFromID2: false,
      userNameFront: '',
      userNameID2: '',
    }
  },
  computed: {
    ...mapState('studentsList', ['studentsList_form']),
  },

  methods: {
    decryptCheckRole,
    ...mapActions('studentsList', ['GET_STUDENTS_LIST', 'GET_EDUCATION_PROGRAMS_BY_NAME',
      'PUT_STUDENT_DATA', 'GET_STUDENT_GROUPS_BY_NAME', 'GET_STUDY_LEVEL_NAMES', 'PUT_STUDENT_DEBT',
      'POST_STUDENT_PREVIOUS_EDUCATION_DOCUMENT', 'POST_UPDATE_STUDENT_DATA', 'POST_UPDATE_STUDENT_ADDITIONAL_DATA']),
    ...mapMutations('studentsList', ['SET_SELECTED_EDUCATION_PROGRAM_ID', 'SET_EDIT_STUDENT_ID',
      'SET_SELECTED_STUDENT_GROUP_ID', 'SET_SELECTED_STUDENT_COURSE', 'SET_SELECTED_STUDENT_STUDY_LEVEL_ID',
      'SET_SELECTED_STUDENT_STUDY_LANGUAGE_ID', 'SET_BARCODE', 'SET_STUDENT_PREVIOUS_EDUCATION_DOCUMENT_DATA',
      'SET_PREVIOUS_EDUCATION_DOCUMENT_STUDENT_ID']),
    toCapitalize,

    async handlePageChange(event) {
      this.page = event.page + 1;
      await this.GET_STUDENTS_LIST({course_id: this.course_id, name: this.name, page: this.page})
    },

    importData() {
      let allData = document.getElementById('alldata').value
      allData = allData.replaceAll(`'`, `"`)

      if (allData) {
        const allDataObj = JSON.parse(allData)

        allDataObj.birth_date = allDataObj.birth_date.split(".").reverse().join("-")
        //allDataObj.valid_from = this.convertDateToTimestamp(allDataObj.valid_from)
        //allDataObj.valid_to = this.convertDateToTimestamp(allDataObj.valid_to)

        allDataObj.last_name = this.toCapitalize(allDataObj.last_name)
        allDataObj.first_name = this.toCapitalize(allDataObj.first_name)
        allDataObj.middle_name = this.toCapitalize(allDataObj.middle_name)
        allDataObj.last_name_en = this.toCapitalize(allDataObj.last_name_en)
        allDataObj.first_name_en = this.toCapitalize(allDataObj.first_name_en)

        return allDataObj
      }
      return null
    },

    openImportFormID2Dialog(studentId) {

      const user = this.studentsList_form.studentsListInfos.find(i => i.id === studentId)
      this.userNameFront = `${user?.last_name} ${user?.first_name}`

      const dataID2 = this.importData()
      if (dataID2) {
        this.formStudentData = {
          student_id: user.id,
          first_name: dataID2.first_name,
          last_name: dataID2.last_name,
          middle_name: dataID2.middle_name,
          first_name_eng: dataID2.first_name_en,
          last_name_eng: dataID2.last_name_en,
        }
        this.formAdditionalData = {
          student_data_id: user.id,
          birth_date: dataID2.birth_date,
          //birth_place: dataID2.birth_place,
          doc_number: dataID2.document_number,
          iin: dataID2.iin,
          doc_given_org: dataID2.issuer,
          doc_given_date: dataID2.valid_from,
          //doc_date_end: dataID2.valid_to,
        }

        this.userNameID2 = `${dataID2?.last_name} ${dataID2?.first_name}`
        this.disabledSaveImportFromID2 = false
      } else {
        this.userNameID2 = `Данные из ID2 не импортированы`
        this.disabledSaveImportFromID2 = true
      }

      this.displayImportFromID2 = true
    },
    closeImportFromID2Dialog() {
      this.displayImportFromID2 = false
    },

    async saveImportFromID2() {
      this.loadingSaveImportFromID2 = true
      console.log(this.formStudentData, 'saveImportFromID2 formStudenData')
      console.log(this.formAdditionalData, 'saveImportFromID2 formAdditionalData')

      const res = await this.POST_UPDATE_STUDENT_DATA(this.formStudentData)
      const resAdd = await this.POST_UPDATE_STUDENT_ADDITIONAL_DATA(this.formAdditionalData)
      if (res && resAdd) {
        this.closeImportFromID2Dialog()
        this.$message({title: 'Данные успешно обновлены'})

        await this.GET_STUDENTS_LIST({course_id: this.course_id, name: this.name, page: this.page})
      }

      this.loadingSaveImportFromID2 = false
    },

    // checkRole(i) {
    //   const roles = JSON.parse(getCookie('ROLES')) || []
    //   if (!roles.length && getCookie('ROLE')) {
    //     roles.push(getCookie('ROLE'))
    //   }
    //   return roles.includes(i)
    // },

    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
    },
    async changeCourse(e) {
      this.course_id = e.target.value

      this.loading = true
      await this.GET_STUDENTS_LIST({course_id: this.course_id, name: this.name, page: this.page})
      this.loading = false;
    },


    async getStudentList() {
      await this.GET_STUDENTS_LIST({course_id: this.course_id, name: this.name, page: 1})
    }
  },
  async mounted() {
    await this.GET_STUDENTS_LIST({course_id: this.course_id, name: this.name, page: this.page})
    this.loading = false
    await this.GET_STUDY_LEVEL_NAMES()
  }
}
</script>

<style scoped>

</style>


<style scoped>

</style>